<div
  class="items relative w-[18rem] overflow-hidden p-md rounded-lg bg-white shadow-md">
  <p class="text-neutral-700 text-xs font-medium mb-sm px-sm">
    {{ 'mention_list_popup_title' | transloco }}
  </p>

  <div
    libScrollBottom
    (scrolledBottom)="loadMore()"
    class="max-h-[21rem] overflow-auto">
    @for (
      item of props()['items'];
      track $index;
      let i = $index;
      let isLast = $last
    ) {
      <button
        type="button"
        class="flex items-center gap-md w-full border-neutral-200 py-sm hover:bg-neutral-100 rounded-md px-sm"
        [class.border-b]="!isLast"
        (click)="selectItem(i)">
        <lib-avatar
          [fullName]="item.label"
          [img]="item.image?.url || ''"
          borderRadius="rounded-full" />

        <div class="flex flex-col w-5/6">
          <p
            [title]="item.label"
            class="truncate text-xs font-medium text-neutral-900 text-left">
            {{ item.label }}
          </p>

          @if (item.department_name) {
            <p
              [title]="item.department_name"
              class="truncate text-xs text-neutral-500 text-left">
              {{ item.department_name }}
            </p>
          }
        </div>
      </button>
    } @empty {
      <p class="text-xs text-neutral-500 text-center">
        {{ 'mention_list_popup_no_data_label' | transloco }}
      </p>
    }

    @if (isLoading()) {
      <div class="text-center">
        <lib-loader size="sm" />
      </div>
    }
  </div>
</div>
